import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { authSelector } from 'selectors/auth/authSelector';
import basketSelector from 'selectors/basket/basketSelector';
import BeautyInsiderSelector from 'selectors/beautyInsider/beautyInsiderSelector';
import userUtils from 'utils/User';
import localeUtils from 'utils/LanguageLocale';
import { isRewardBundlingEnabled, countDistinctSthRewards } from 'utils/BeautyInsider';
import Actions from 'Actions';
import getModal from 'services/api/cms/getModal';
import BeautyInsiderAllRewardsEN from 'components/Content/BeautyInsider/BeautyInsiderAllRewards/locales/BeautyInsiderAllRewards_en_US';
import BeautyInsiderAllRewardsFR from 'components/Content/BeautyInsider/BeautyInsiderAllRewards/locales/BeautyInsiderAllRewards_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { beautyInsiderSelector } = BeautyInsiderSelector;

const getText = localeUtils.getLocalisedDataFromResource(BeautyInsiderAllRewardsEN, BeautyInsiderAllRewardsFR);

const REWARD_BUNDLING_MODAL_SID = 'Reward_Bundling_Modal';

const fields = createSelector(userSelector, authSelector, basketSelector, beautyInsiderSelector, (user, auth, basket, beautyInsider) => {
    return {
        isAnonymous: user.isInitialized && userUtils.isAnonymous(auth),
        user,
        auth,
        basket,
        biRewardGroups: beautyInsider.biRewardGroups || {},
        isRewardBundlingEnabled: isRewardBundlingEnabled(),
        has100PtRewardsAvailable: (beautyInsider.biRewardGroups?.['100 Points']?.length || 0) > 0,
        totalAccountPoints: basket.availableBiPoints || 0,
        sthRewardCount: countDistinctSthRewards(basket.itemsByBasket),
        localization: {
            allRewards: getText('allRewards'),
            addFullSize: getText('addFullSize'),
            rougeBadge: getText('rougeBadge'),
            freeShipping: getText('freeShipping')
        }
    };
});

const functions = dispatch => ({
    onTermsTap: async () => {
        const { country, channel, language } = Sephora.renderQueryParams || {};

        try {
            const modalContent = await getModal({
                country,
                channel,
                language,
                sid: REWARD_BUNDLING_MODAL_SID
            });

            dispatch(
                Actions.showContentModal({
                    isOpen: true,
                    data: {
                        sid: REWARD_BUNDLING_MODAL_SID,
                        title: modalContent?.title,
                        body: modalContent?.body
                    }
                })
            );
        } catch (error) {
            Sephora.logger.error('RewardBundling: Terms modal fetch failed', error);
        }
    }
});

const withBeautyInsiderAllRewardsProps = wrapHOC(connect(fields, functions));

export {
    withBeautyInsiderAllRewardsProps, fields, functions
};
